import { CalendarBlankOutlineIcon } from './CalendarBlankOutlineIcon';

/**
 * author: Google
 * id 9A461143-6DF3-49CB-A238-24CFE7181183
 * name calendar-blank-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-blank-outline.svg
 * tags
 * - Date / Time 
 */
export const EventBlankOutlineIcon = CalendarBlankOutlineIcon;
export default EventBlankOutlineIcon